import { schemaDiscriminator as e } from "../discriminator-metadata.js";
import { compositions as t } from "./schema-composition.js";
import { resolve as n } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/optimize-value-for-display.ts
function r(...e) {
	let t = {}, n = {}, r = /* @__PURE__ */ new Set(), i = !1, a = !1;
	for (let o of e) if (o) for (let [e, s] of Object.entries(o)) {
		if (e === "properties" && s && typeof s == "object") {
			Object.assign(n, s), i = !0;
			continue;
		}
		if (e === "required" && Array.isArray(s)) {
			for (let e of s) r.add(e);
			a = !0;
			continue;
		}
		t[e] = s;
	}
	return i && (t.properties = n), a && (t.required = [...r]), t;
}
function i(i) {
	if (!i || typeof i != "object" || i[e]?.inheritedVariants) return i;
	let a = t.find((e) => e in i && e !== "not");
	if (!a) return { ...i };
	let o = i[a];
	if (!Array.isArray(o)) return { ...i };
	let { [a]: s, nullable: c, ...l } = i, u = Object.keys(l).length > 0, { filteredSchemas: d, hasNullSchema: f } = o.reduce((e, t) => {
		let r = n.schema(t);
		return "type" in r && r.type === "null" ? e.hasNullSchema = !0 : e.filteredSchemas.push(r), e;
	}, {
		filteredSchemas: [],
		hasNullSchema: !1
	}), p = f || c === !0;
	if (d.length === 1) {
		let e = r(d[0], l);
		return p && (e.nullable = !0), e;
	}
	if ((a === "oneOf" || a === "anyOf") && (u || d.some((e) => e.allOf))) {
		let { discriminator: e, ...t } = l, o = d.map((e) => {
			let i = n.schema(e);
			if (i.allOf?.length === 1) {
				let { allOf: e, ...a } = i, o = n.schema(e[0]);
				if ("properties" in a || "required" in a || "$ref" in a) {
					let { $ref: e, title: n, name: i, ...s } = o;
					return r(t, a, s);
				}
				return r(t, a, o);
			}
			return r(t, i);
		}), s = { [a]: o };
		return typeof i.description == "string" && (s.description = i.description), p && (s.nullable = !0), s;
	}
	if (d.length !== o.length) {
		let e = {
			...i,
			[a]: d
		};
		return p && (e.nullable = !0), e;
	}
	return { ...i };
}
//#endregion
export { i as optimizeValueForDisplay };

//# sourceMappingURL=optimize-value-for-display.js.map